import * as keyapis_identity_v1_authorization_pb from "./v1/keyapis_identity_authorization_v1.pb";
import * as keyapis_identity_v1_system_pb from "./v1/keyapis_identity_system_v1.pb";
import * as keyapis_identity_v1_token_pb from "./v1/keyapis_identity_token_v1.pb";

export default {
  v1: {
    resources: {
      authorization: keyapis_identity_v1_authorization_pb,
      system: keyapis_identity_v1_system_pb,
      token: keyapis_identity_v1_token_pb,
    },
  },
};
